import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterMuizenberg() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-muizenberg",
    name: "Painters Muizenberg",
    location: "Muizenberg, Cape Town",
    rating: 4.8,
    reviews: 165,
    specialties: ["Beach Properties", "Surf Town Homes", "Coastal Painting", "Victorian Restoration"],
    image: "https://public.readdy.ai/ai/img_res/625f987b6bacaaabd4a88880380343a0.jpg",
    verified: true,
    yearsExperience: 15,
    website: "https://paintersmuizenberg.co.za",
    email: "info@paintersmuizenberg.co.za",
    phone: "+27 21 555 0133",
    description: "Professional painting services in Muizenberg and surrounding False Bay areas. We specialize in beach properties and Victorian homes with expertise in marine-grade finishes that withstand coastal conditions.",
    services: [
      "Interior House Painting",
      "Exterior House Painting", 
      "Beach Property Painting",
      "Victorian Home Restoration",
      "Roof Painting & Coatings",
      "Waterproofing Services",
      "Damp Proofing Solutions",
      "Color Consultation & Design"
    ],
    serviceAreas: ["Muizenberg", "St James", "Kalk Bay", "Fish Hoek", "Lakeside", "Marina da Gama", "False Bay"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20interior%20living%20room%20painted%20by%20professional%20painters%20in%20Muizenberg%20Cape%20Town%2C%20Victorian%20beach%20home%20with%20fresh%20painted%20walls%20and%20ocean%20views%2C%20quality%20paint%20finish%2C%20False%20Bay%20scenery%20visible%20through%20windows%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work%20with%20period%20features%20and%20beach%20decor&width=400&height=300&seq=muizenberg-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20house%20painting%20project%20in%20Muizenberg%20Cape%20Town%20South%20Africa%2C%20colorful%20Victorian%20beach%20home%20with%20fresh%20paint%20near%20famous%20surf%20beach%2C%20professional%20painters%20working%20on%20scaffolding%2C%20quality%20exterior%20finish%2C%20beachfront%20setting%20with%20mountain%20views%2C%20well-maintained%20historic%20property&width=400&height=300&seq=muizenberg-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Beach%20house%20painting%20project%20in%20Muizenberg%20False%20Bay%2C%20professional%20painters%20working%20on%20surf%20town%20property%20exterior%2C%20quality%20residential%20paint%20finish%2C%20Victorian%20coastal%20architecture%20with%20ocean%20views%2C%20organized%20work%20site%20with%20painting%20equipment%20and%20materials&width=400&height=300&seq=muizenberg-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Kitchen%20interior%20painting%20in%20Muizenberg%20beach%20home%20Cape%20Town%2C%20fresh%20painted%20walls%20in%20modern%20kitchen%2C%20quality%20paint%20finish%20with%20coastal%20color%20scheme%2C%20bright%20clean%20space%20with%20ocean%20views%2C%20professional%20painting%20work%20with%20contemporary%20fixtures%20and%20beach%20style%20appliances&width=400&height=300&seq=muizenberg-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Bedroom%20interior%20painting%20in%20Muizenberg%20Victorian%20beach%20home%2C%20fresh%20painted%20walls%20in%20master%20bedroom%2C%20coastal%20design%20with%20False%20Bay%20ocean%20views%2C%20quality%20paint%20finish%2C%20bright%20airy%20space%2C%20professional%20painting%20work%20with%20beach%20decor%20and%20natural%20lighting&width=400&height=300&seq=muizenberg-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20Victorian%20beach%20home%20painting%20in%20Muizenberg%20Cape%20Town%2C%20professional%20painters%20applying%20marine-grade%20paint%20to%20historic%20property%20near%20surf%20beach%2C%20False%20Bay%20ocean%20backdrop%2C%20quality%20exterior%20finish%20with%20weather%20protection%2C%20organized%20professional%20work%20site%20with%20safety%20equipment&width=400&height=300&seq=muizenberg-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Emma Richardson",
        rating: 5,
        comment: "Fantastic work on our Muizenberg beach house. The team understood the unique coastal challenges and delivered a beautiful, vibrant finish that perfectly suits the surf town atmosphere."
      },
      {
        name: "Johan Pretorius", 
        rating: 5,
        comment: "Excellent restoration work on our Victorian home. They respected the historic character while providing modern coastal protection. Highly recommend for Muizenberg properties."
      },
      {
        name: "Lisa Thompson",
        rating: 4,
        comment: "Professional painters who know beach properties well. Great attention to detail and the finish has held up perfectly against the salt air and ocean conditions."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Muizenberg | Professional Beach Painting Services Cape Town | Victorian Home Painters";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Muizenberg offers professional painting services for beach properties and Victorian homes in Muizenberg, Cape Town. Specializing in coastal painting, marine-grade finishes, and historic restoration.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Muizenberg, house painters Muizenberg, beach property painting Cape Town, Victorian home restoration, coastal painting contractors');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-gray-900 to-black text-white py-32 min-h-[70vh] flex items-center">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20stunning%20colorful%20Victorian%20beach%20house%20in%20Muizenberg%20Cape%20Town%20South%20Africa%2C%20spectacular%20False%20Bay%20ocean%20views%20with%20famous%20surf%20beach%20and%20colorful%20beach%20huts%2C%20painters%20in%20clean%20uniforms%20applying%20paint%20with%20brushes%20and%20rollers%2C%20historic%20coastal%20architecture%2C%20bright%20sunny%20day%2C%20pristine%20work%20environment%20with%20professional%20equipment&width=1200&height=600&seq=muizenberg-painters-hero-bg&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl">
            <div className="inline-block bg-lime-400 text-black px-4 py-2 rounded-full text-sm font-semibold mb-6">
              <i className="ri-shield-check-line mr-2"></i>
              VERIFIED PROFESSIONAL PAINTER
            </div>
            <h1 className="text-5xl lg:text-6xl font-bold leading-tight mb-6">
              Painters Muizenberg
            </h1>
            <p className="text-2xl text-gray-300 mb-4">
              Beach Property & Victorian Home Painting Specialists
            </p>
            <p className="text-lg text-gray-400 mb-8 leading-relaxed">
              Muizenberg's premier painting contractors specializing in beach properties, Victorian homes, and coastal residences. With over 15 years of experience serving the False Bay coastline, we combine traditional craftsmanship with modern marine-grade materials to deliver exceptional results that withstand the coastal environment.
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* Main Content Area */}
            <div className="lg:col-span-2">
              {/* Navigation Tabs */}
              <nav className="flex space-x-8">
                {[
                  { id: 'overview', label: 'Overview' },
                  { id: 'services', label: 'Services' },
                  { id: 'gallery', label: 'Gallery' },
                  { id: 'reviews', label: 'Reviews' },
                  { id: 'contact', label: 'Contact' }
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                      activeTab === tab.id
                        ? 'border-lime-500 text-lime-600'
                        : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                    }`}
                  >
                    {tab.label}
                  </button>
                ))}
              </nav>

              {/* Tab Content */}
              <div className="bg-white rounded-xl shadow-lg p-8">
                {activeTab === 'overview' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">About Painters Muizenberg</h2>
                      <div className="prose prose-lg max-w-none text-gray-700 space-y-4">
                        <p className="leading-relaxed">
                          Welcome to Painters Muizenberg, the False Bay area's most trusted and experienced painting contractor for beach properties and Victorian homes. For over 15 years, we have been the preferred choice for homeowners throughout Muizenberg, St James, Kalk Bay, and the surrounding coastal areas who value exceptional craftsmanship, attention to detail, and long-lasting protection for their properties.
                        </p>
                        <p className="leading-relaxed">
                          Our reputation has been carefully built over more than a decade and a half through consistent delivery of superior quality workmanship, honest and transparent business practices, and an unwavering commitment to customer satisfaction. We understand that Muizenberg is a unique and special place, famous for its colorful beach huts, historic Victorian architecture, and vibrant beach culture. The properties in this area, from charming Victorian cottages to modern beach houses, require specialized care and expertise to maintain their beauty and structural integrity in the challenging coastal environment.
                        </p>
                        <p className="leading-relaxed">
                          What truly sets Painters Muizenberg apart from other painting contractors is our deep understanding and appreciation of both the architectural heritage and the environmental challenges that define this iconic beachside community. The combination of salt-laden ocean breezes from False Bay, high humidity levels, strong south-easterly winds, intense UV radiation, and occasional sand-laden air requires specialized knowledge, carefully selected marine-grade materials, and proven application techniques that we have perfected over years of experience working in this unique coastal environment.
                        </p>
                        <p className="leading-relaxed">
                          We take particular pride in our work on Victorian-era properties throughout Muizenberg. These historic buildings, many dating back to the late 1800s and early 1900s, require special care, sensitivity, and expertise to preserve their character and architectural details while ensuring they remain protected and functional for future generations. Our team has extensive experience working with heritage structures, understanding the importance of using appropriate materials and techniques that respect the building's original construction methods while providing modern levels of protection and durability. We work closely with heritage consultants and local authorities when required to ensure all work meets conservation standards and regulations.
                        </p>
                        <p className="leading-relaxed">
                          Our comprehensive approach to every painting project begins with a thorough initial consultation and detailed property assessment. We take the time to understand your specific needs, preferences, budget, and concerns, carefully examining the condition of all surfaces to be painted, identifying any underlying issues such as moisture damage, wood rot, or structural problems that need to be addressed, and considering factors such as exposure to elements, substrate type, previous coating history, and architectural style. Based on this detailed assessment, we provide expert recommendations and a transparent, itemized quote with no hidden costs or surprises.
                        </p>
                        <p className="leading-relaxed">
                          Surface preparation is where quality painting truly begins, and it's an area where we never compromise or cut corners. We understand that even the finest, most expensive paint will fail prematurely if applied to poorly prepared surfaces. Our preparation process is thorough and meticulous, including pressure washing, scraping, sanding, filling, caulking, priming, and any necessary repairs to wood, plaster, or other substrates. We address issues such as peeling paint, cracks, holes, water damage, mold growth, and substrate deterioration before any new coatings are applied. This attention to detail in the preparation phase is what ensures the longevity, beauty, and protective qualities of the final result.
                        </p>
                        <p className="leading-relaxed">
                          Our team of skilled painters are experienced craftsmen who take genuine pride in their work and understand the importance of delivering flawless results. Each team member has been carefully selected not only for their technical painting skills but also for their reliability, professionalism, work ethic, and commitment to excellence. We invest heavily in ongoing training and professional development to ensure our team stays current with the latest products, techniques, safety standards, and industry best practices. This dedication to continuous improvement and skill development means you benefit from the most advanced and effective painting solutions available in the market today.
                        </p>
                        <p className="leading-relaxed">
                          Over our 15 years of operation in the Muizenberg area, we have built an impressive and diverse portfolio of completed projects. From charming Victorian cottages and historic beach houses to modern family homes and luxury coastal properties, we have successfully completed hundreds of projects of all sizes, styles, and complexity levels. Each project receives the same level of dedication, professionalism, and attention to detail, regardless of its scope or budget. We treat every home as if it were our own, ensuring that the final result not only meets but consistently exceeds your expectations.
                        </p>
                        <p className="leading-relaxed">
                          At Painters Muizenberg, we believe in building long-term relationships with our clients based on trust, transparency, reliability, and consistently excellent results. Many of our customers have been with us for years, returning for regular maintenance work, renovations, and new projects. They enthusiastically recommend us to their friends, family, neighbors, and colleagues because they know they can rely on us to deliver superior quality, honest advice, fair pricing, and professional service every single time. This loyalty and trust is something we deeply value and never take for granted, and it drives us to maintain our high standards on every project, no matter how large or small.
                        </p>
                        <p className="leading-relaxed">
                          We use only premium, environmentally responsible paints and materials from leading manufacturers including Plascon, Dulux, and specialized marine coating suppliers. These products are specifically formulated to provide superior adhesion, durability, color retention, and resistance to the harsh coastal conditions found in Muizenberg and along the False Bay coastline. By investing in the best materials available and applying them with expert technique and care, we ensure that your paint job not only looks stunning on completion day but continues to look great and provide protection for many years to come, maximizing the value of your investment and minimizing the need for frequent repainting.
                        </p>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Why Choose Painters Muizenberg?</h3>
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-award-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">15+ Years Experience</h4>
                            <p className="text-gray-600 text-sm">Over fifteen years of proven excellence in beach property and Victorian home painting throughout Muizenberg.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-building-2-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Victorian Home Specialists</h4>
                            <p className="text-gray-600 text-sm">Extensive experience working with historic Victorian properties, preserving architectural character and details.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-shield-check-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Fully Insured & Certified</h4>
                            <p className="text-gray-600 text-sm">Comprehensive liability insurance and professional certifications for your complete peace of mind.</p>
                          </div>
                        </div>
                        <div className="flex items-start space-x-4">
                          <div className="w-12 h-12 bg-lime-100 rounded-lg flex items-center justify-center flex-shrink-0">
                            <i className="ri-customer-service-line text-lime-600 text-xl"></i>
                          </div>
                          <div>
                            <h4 className="font-semibold text-gray-900 mb-2">Exceptional Service</h4>
                            <p className="text-gray-600 text-sm">Professional communication, respect for your property, and commitment to exceeding expectations.</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="border-t pt-8">
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Our Service Areas</h3>
                      <p className="text-gray-700 mb-4 leading-relaxed">
                        Painters Muizenberg proudly serves the entire False Bay coastline and surrounding areas, including:
                      </p>
                      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                        {['Muizenberg', 'St James', 'Kalk Bay', 'Fish Hoek', 'Clovelly', 'Lakeside', 'Marina da Gama', 'Sunrise Beach', 'Sandvlei'].map((area) => (
                          <div key={area} className="flex items-center space-x-2 text-gray-700">
                            <i className="ri-map-pin-line text-lime-600"></i>
                            <span>{area}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'services' && (
                  <div className="space-y-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Our Comprehensive Painting Services</h2>
                      <p className="text-gray-700 mb-8 leading-relaxed">
                        At Painters Muizenberg, we offer a complete range of professional painting services tailored to the unique needs of beach properties, Victorian homes, and coastal residences. Our expertise covers every aspect of residential painting, from initial consultation through to final inspection and beyond.
                      </p>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-building-2-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Victorian Home Restoration</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Specialized painting and restoration services for historic Victorian properties throughout Muizenberg. We use traditional techniques combined with modern protective coatings to preserve architectural character while ensuring long-lasting protection and beauty.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Victorian and Edwardian era properties</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Historic beach houses and cottages</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Period-appropriate color schemes and finishes</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Preservation of architectural details and features</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-home-4-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Beach Property Painting</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Specialized painting services for beach houses and coastal properties. We use premium marine-grade paints and advanced application techniques designed to withstand salt spray, sand, UV radiation, and moisture from the ocean environment.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Beach houses and holiday homes</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Marine-grade protective coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Salt and sand-resistant finishes</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>UV-resistant exterior coatings</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-paint-brush-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Interior Painting Services</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Transform your living spaces with our premium interior painting services. We specialize in creating beautiful, durable finishes that enhance your home's aesthetic appeal while providing long-lasting protection. Our meticulous preparation ensures flawless results.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Living rooms, bedrooms, and entertainment areas</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Kitchens and bathrooms with moisture-resistant coatings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Ceilings, cornices, and decorative moldings</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Doors, windows, and trim work</span>
                          </li>
                        </ul>
                      </div>

                      <div className="bg-gray-50 rounded-xl p-6 hover:shadow-lg transition-shadow">
                        <div className="w-14 h-14 bg-lime-400 rounded-lg flex items-center justify-center mb-4">
                          <i className="ri-shield-line text-black text-2xl"></i>
                        </div>
                        <h3 className="text-xl font-bold text-gray-900 mb-3">Waterproofing & Protection</h3>
                        <p className="text-gray-700 mb-4 leading-relaxed">
                          Essential for coastal properties, our comprehensive waterproofing services protect your investment from water damage, mold growth, and structural deterioration. We use advanced waterproofing systems specifically designed for the False Bay coastal environment.
                        </p>
                        <ul className="space-y-2 text-gray-600 text-sm">
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Exterior wall waterproofing and sealing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Roof waterproofing and coating systems</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Balcony and deck waterproofing</span>
                          </li>
                          <li className="flex items-start">
                            <i className="ri-check-line text-lime-600 mr-2 mt-1"></i>
                            <span>Damp proofing and moisture barrier installation</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {activeTab === 'gallery' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Project Gallery</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {painter.gallery.map((image, index) => (
                        <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                          <img 
                            src={image} 
                            alt={`${painter.name} project ${index + 1}`}
                            className="w-full h-64 object-cover object-top"
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'reviews' && (
                  <div>
                    <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews</h2>
                    <div className="space-y-6">
                      {painter.testimonials.map((testimonial, index) => (
                        <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                          <div className="flex items-center mb-4">
                            <div className="flex items-center">
                              {[...Array(5)].map((_, i) => (
                                <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                              ))}
                            </div>
                            <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                          </div>
                          <p className="text-gray-700">{testimonial.comment}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'contact' && (
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div>
                      <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Information</h2>
                      <div className="space-y-6">
                        <div className="flex items-center">
                          <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Email</h3>
                            <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                              {painter.email}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-center">
                          <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Website</h3>
                            <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                              {painter.website}
                            </a>
                          </div>
                        </div>
                        
                        <div className="flex items-start">
                          <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                          <div>
                            <h3 className="font-semibold text-gray-900">Service Area</h3>
                            <p className="text-gray-700">{painter.location} and surrounding areas</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div>
                      <h3 className="text-2xl font-bold text-gray-900 mb-6">Get a Quote</h3>
                      <button 
                        onClick={() => navigate('/quote')}
                        className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                      >
                        Request Free Quote
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            {/* Sidebar */}
            <div>
              <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                <div className="mb-6">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20Victorian%20beach%20home%20in%20Muizenberg%20Cape%20Town%2C%20False%20Bay%20surf%20beach%20property%20with%20colorful%20beach%20huts%2C%20painters%20in%20uniform%20with%20quality%20equipment%2C%20historic%20coastal%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=muizenberg-sidebar-image&orientation=landscape"
                    alt="Professional painters Muizenberg beach house painting services Cape Town False Bay"
                    className="w-full h-48 object-cover object-top rounded-lg"
                  />
                </div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                <div className="space-y-4">
                  <div className="flex items-center">
                    <i className="ri-mail-line mr-3 text-lime-500"></i>
                    <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                      {painter.email}
                    </a>
                  </div>
                  <div className="flex items-center">
                    <i className="ri-global-line mr-3 text-lime-500"></i>
                    <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                      Visit Website
                    </a>
                  </div>
                </div>
                
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Get Free Quote
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
